import React from 'react'
import { Button } from 'antd'

import { NewTabIcon } from 'admin/lib/Icons/NewTabIcon'
import * as CLIENT_ROUTES from 'admin/routes-to-client'

export const QuickLink: React.FC<{
  loaded: boolean
  record: any
  accountId: string
  moduleName: string
}> = ({ loaded, record, accountId, moduleName }) => {
  if (loaded) {
    const href = CLIENT_ROUTES.RECORD.VIEW.replace(':accountId', accountId)
      .replace(':projectId', record.projectId)
      .replace(':moduleName', moduleName.toLowerCase())
      .replace(':recordId', record.recordId)

    return (
      <Button icon={<NewTabIcon />} href={href} target="_blank">
        View in Client Portal
      </Button>
    )
  }

  return null
}
